import { VuesticPluginFabric } from '../types'

export const defineVuesticPlugin = <O extends any[]>(fabric: VuesticPluginFabric<O>) => fabric
